import type { Middleware } from "redux";

import * as actionTypes from "@/redux/actions/actionTypes";
import { user_patient } from "@/config/roles";

export const patientAuthMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);

  if (
    (action.type === actionTypes.AUTH_SUCCESS && action.role === user_patient) ||
    action.type === actionTypes.SHOW_EMAIL_VERIFIED
  ) {
    // Payload inlined instead of using allowLoginPopUps() action creator to avoid a
    // circular import: patient.js → api/(requests)/patient.js → api/auth.ts → api/base.ts
    //                  → api/hooks/errorShape.ts → redux/store.js → this file
    store.dispatch({
      payload: { allowInactivePopUp: true, allowWaitListPopUp: true },
      type: actionTypes.ALLOW_LOGIN_POP_UPS,
    });
  }

  return result;
};
